import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MUTATION_TYPES } from './constants';

// This component is a wrapper around the <MutationObserver> API to detect mutations
// to DOM nodes. This can be more performant than relying on React to keep track of these
// changes directly because the methods called by the Subject are treated as first-class
// microtasks

export default class Mutations extends Component {
  static propTypes = MUTATION_TYPES;

  childNode = null;
  observer = null;

  componentDidMount() {
    if (this.childNode == null) {
      throw new Error('ObserveMutations did not receive a ref to observe');
    }
  }

  updateChildNode = (ref) => {
    if (this.childNode === ref) {
      return;
    }

    this.childNode = ref;
    if (this.observer != null) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.childNode != null) {
      this.observer = new MutationObserver(this.onMutation);
      this.observer.observe(this.childNode, this.props.observerOptions);
    }
  };

  onMutation = (...args) => {
    this.props.onMutation(...args);
  };

  render() {
    return this.props.children(this.updateChildNode);
  }
}
